import React from "react";
import { cn } from "@RHCommerceDev/utils/cn";

const RHAccountIconV2 = ({
  className,
  strokeWidth = 0.75,
  ...restProps
}: React.ComponentProps<"svg">) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("", className)}
    {...restProps}
  >
    <path
      d="M5.37543 19.4979H19.2354V14.5083C19.2354 13.2544 18.2189 12.2379 16.965 12.2379H7.64581C6.39192 12.2379 5.37543 13.2544 5.37543 14.5083V19.4979Z"
      stroke="currentColor"
      stroke-width={strokeWidth}
    />
    <path
      d="M15.5601 6.63C15.5601 8.42769 14.1028 9.885 12.3051 9.885C10.5074 9.885 9.05011 8.42769 9.05011 6.63C9.05011 4.83231 10.5074 3.375 12.3051 3.375C14.1028 3.375 15.5601 4.83231 15.5601 6.63Z"
      stroke="currentColor"
      stroke-width={strokeWidth}
    />
  </svg>
);

export default RHAccountIconV2;
